import PropTypes from 'prop-types';
import React from 'react';
import i18next from 'i18next';

import { timeFrom, getFormattedTimeString } from 'lib/DateTime';

function TimeAgo(props, context) {
  const { dateString } = props;

  // Amp articles are rendered server side.
  // As such we do not have access to the clients
  // timezone. Rather than display UTC we explicitly
  // set date to be formatted in eastern time.
  const { amp: isAmpArticle } = context;
  const ianaEasternTimeZone = 'America/New_York';
  const timeZone = isAmpArticle ? ianaEasternTimeZone : undefined;

  const formattedDaysFromDate = timeFrom(dateString);
  const formattedTime = getFormattedTimeString(dateString, timeZone);

  return (
    <div className="timestamps founders-mono f2" data-test="timestamp">
      {`${i18next.t('time_ago', { time: formattedDaysFromDate })} / ${formattedTime}`}
    </div>
  );
}

TimeAgo.propTypes = {
  dateString: PropTypes.string.isRequired,
};

TimeAgo.contextTypes = {
  amp: PropTypes.bool,
};

export default TimeAgo;
